import React from 'react';
import ConditionGoals from 'components/molecules/conditions-goals';

interface IAdminTabbedFormConditionsProps {
  patientGuid: string;
  readOnly?: boolean;
}

const AdminTabbedFormConditions: React.FC<IAdminTabbedFormConditionsProps> = (
  props,
) => {
  const { patientGuid, readOnly } = props;

  return (
    <ConditionGoals
      patientGuid={patientGuid}
      disableActions={readOnly}
      isSingle
      withoutDivider
    />
  );
};

export default AdminTabbedFormConditions;
